import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container mx-auto sm:px-4 pt-[3.9rem]" }
const _hoisted_2 = { class: "xl:flex xl:flex-wrap -mx-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CheckoutLeftPane = _resolveComponent("CheckoutLeftPane")!
  const _component_CheckoutRightPane = _resolveComponent("CheckoutRightPane")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_CheckoutLeftPane, {
        "show-appointment-title": _ctx.showAppointmentTitle,
        "content-column-class": _ctx.contentColumnClass
      }, null, 8, ["show-appointment-title", "content-column-class"]),
      _createVNode(_component_CheckoutRightPane, { "show-desktop-doctor-card": _ctx.showDesktopDoctorCard }, null, 8, ["show-desktop-doctor-card"])
    ])
  ]))
}